import { ClientId, CommunityId, HomeCareLeadId } from "@sp-crm/core";
import {
    AdvancedSearchEntityType,
    ClientContactRelationship,
    HomeCareLeadContactRelationship,
} from "generated/graphql";

export type ContactEditorEntity =
    | {
          type: AdvancedSearchEntityType.Client;
          clientId: ClientId;
          relationship: ClientContactRelationship;
      }
    | {
          type: AdvancedSearchEntityType.HomeCareLead;
          homeCareLeadId: HomeCareLeadId;
          relationship: HomeCareLeadContactRelationship;
      }
    | { type: AdvancedSearchEntityType.Community; communityId: CommunityId };

export interface EditorPolicy {
    showRole: boolean;
    showAddress: boolean;
    allowReferralContactTracking: boolean;
    showPrimaryContact: boolean;
    showRelationship: boolean;
    showPowerOfAttorney: boolean;
    showProviderType: boolean;
    showBusinessName: boolean;
    showCellPhone: boolean;
    showFax: boolean;
}

export const getEditorPolicy = (entity: ContactEditorEntity): EditorPolicy => {
    switch (entity.type) {
        case AdvancedSearchEntityType.Community:
            return {
                showRole: true,
                showAddress: false,
                allowReferralContactTracking: true,
                showPrimaryContact: true,
                showRelationship: false,
                showPowerOfAttorney: false,
                showProviderType: false,
                showBusinessName: false,
                showCellPhone: true,
                showFax: false,
            };
        case AdvancedSearchEntityType.Client: {
            const isMore = entity.relationship === ClientContactRelationship.MoreContact;
            const isCare = entity.relationship === ClientContactRelationship.CareProvider;
            return {
                showRole: false,
                showAddress: true,
                allowReferralContactTracking: false,
                showPrimaryContact: false,
                showRelationship: isMore,
                showPowerOfAttorney: isMore,
                showProviderType: isCare,
                showBusinessName: isCare,
                showCellPhone: !isCare,
                showFax: isCare,
            };
        }
        case AdvancedSearchEntityType.HomeCareLead: {
            const isMore =
                entity.relationship === HomeCareLeadContactRelationship.MoreContact;
            const isCare =
                entity.relationship === HomeCareLeadContactRelationship.CareProvider;
            return {
                showRole: false,
                showAddress: isMore,
                allowReferralContactTracking: false,
                showPrimaryContact: false,
                showRelationship: isMore,
                showPowerOfAttorney: isMore,
                showProviderType: isCare,
                showBusinessName: isCare,
                showCellPhone: !isCare,
                showFax: isCare,
            };
        }
    }
};
